// src/pages/ThankyouPage.js
import React, { useState, useEffect } from "react";
import { IMAGES } from "../assets/image";
import "../pages/ThankyouPage.css";
import { CREDIT_UNION } from "../assets/constants";
import Footer from "../components/common/Footer";
import { Modal, Button } from "react-bootstrap";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import ApplicationService from "../services/ApplicationService";
import ApplicationContext from "../contexts/applicationContext";

const ThankyouPage = () => {
  const [showModal, setShowModal] = useState(false);
  const [rating, setRating] = useState(0);
  const [hovered, setHovered] = useState(0);

  useEffect(() => {
    setTimeout(() => setShowModal(true), 1000); // auto-show modal after 1s
  }, []);

  const handleSubmitRating = async () => {
    try {
      const guid = localStorage.getItem('current_guid');
      if (!guid) {
        console.error('GUID missing. Cannot save review.');
        return;
      }
  
      const response = await ApplicationService.saveAppReview({ guid, rating });
      console.log('Review saved:', response);
      setShowModal(false);
      clearFormState();
    } catch (error) {
      console.error('Failed to save review:', error.response?.data || error.message);
    }
  };
  
  const clearFormState = () => {
  const guid = localStorage.getItem('current_guid');
  if (guid) {
    localStorage.removeItem('current_guid');
    localStorage.removeItem(`submitted_${guid}`);
    // optionally remove resume key if structure is known
    // localStorage.removeItem(`${lastName}_${dob}_${zip}`);
  }
  sessionStorage.removeItem('current_guid');
  sessionStorage.removeItem('app_draft_data');
};


  return (
    <>
      <section className={`thankyou-page ${showModal ? 'blurred' : ''}`}>
        <div className="thankyou-background">
          <img
            src={IMAGES.SlideShowImage}
            alt="Thankyou Background"
            className="thankyou-bg-img"
          />
        </div>

        <div className="thankyou-overlay" />

        <div className="layout-container thankyou-content">
          <div className="text-container">
            <h2 className="thankyou-title">
              <span className="hero-color">Great! </span>Thank You For Submitting The Application Form
            </h2>
            <p className="thankyou-subtitle">
              Your application will be reviewed. If we have any questions, one of our loan specialists will contact you.  
              For now, feel free to reach us at <span className="hero-color">{CREDIT_UNION.INFO.PHONE}</span> or <span className="hero-color">{CREDIT_UNION.INFO.EMAIL}</span>.
            </p>
          </div>
        </div>
      </section>

      <Modal show={showModal} onHide={() => setShowModal(false)}  centered  backdrop="static"  className="rating-modal">
      <Modal.Body className="text-center py-4 px-5">
        <h4 className="mb-2" style={{ fontWeight: 600 }}> How was your experience?</h4>
        <p className="text-muted mb-4">
          Please rate us. Your feedback helps us improve.
        </p>
        <div style={{ fontSize: "2rem" }}>
          {[1, 2, 3, 4, 5].map((star) =>
            star <= (hovered || rating) ? (
              <AiFillStar key={star} style={{ cursor: "pointer", color: "#ffc107" }} onClick={() => setRating(star)} onMouseEnter={() => setHovered(star)}  onMouseLeave={() => setHovered(0)} />
            ) : (
              <AiOutlineStar  key={star} style={{ cursor: "pointer", color: "#ffc107" }} onClick={() => setRating(star)} onMouseEnter={() => setHovered(star)} onMouseLeave={() => setHovered(0)} />
            )
          )}
        </div>
        <div className="d-flex justify-content-center gap-3 mt-4">
          <Button variant="outline-secondary" onClick={() =>{ setShowModal(false); clearFormState(); }}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSubmitRating} disabled={rating === 0}>
            Submit
          </Button>
        </div>
      </Modal.Body>
</Modal>


      <Footer />
    </>
  );
};

export default ThankyouPage;
